/* Protein Bodega — global patch v10 */
(function () {
  'use strict';

  var REMAP = { '48247575773410': '48224854704354' };
  var SCOPES = ['#car1', '#addoncar', '#treatcar', '#pb-upsell-all'];
  var CARD_SEL = '.meal, .pb-uc';
  var DROP_NAV = ['wellness', 'bienestar'];

  var SEALS = [
    { en: 'Le Cordon Bleu Chef', es: 'Chef Le Cordon Bleu' },
    { en: 'No Seed Oils', es: 'Sin aceites de semilla' },
    { en: 'Macro Labeled', es: 'Macros etiquetados' }
  ];

  var BAG_SVG =
    '<svg class="pb-bag" viewBox="0 0 24 24" width="19" height="19" fill="none" ' +
    'stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" ' +
    'aria-hidden="true" focusable="false">' +
    '<path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>' +
    '<path d="M3 6h18"></path><path d="M16 10a4 4 0 0 1-8 0"></path></svg>';

  var LIVE = null, LOADED = false;

  function money(cents) {
    var n = parseFloat(cents);
    if (isNaN(n)) return '';
    n = n / 100;
    return '$' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2));
  }

  function loadLive() {
    if (LOADED) return Promise.resolve(LIVE);
    return fetch('/collections/all/products.json?limit=250')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        LIVE = {};
        (data.products || []).forEach(function (p) {
          var img = (p.images && p.images[0] && p.images[0].src) || null;
          (p.variants || []).forEach(function (v) {
            var tags = (p.tags || []).map(function (tag) { return String(tag).toLowerCase(); });
            var type = String(p.product_type || '').toLowerCase();
            var isPlan = type.indexOf('meal plan') !== -1 || tags.indexOf('plan') !== -1 || tags.indexOf('meal-plan') !== -1;
            LIVE[String(v.id)] = {
              title: p.title,
              handle: p.handle,
              price: money(parseFloat(v.price) * 100),
              img: img,
              isPlan: isPlan,
              variantTitle: v.title
            };
          });
        });
        LOADED = true;
        return LIVE;
      })
      .catch(function () { LOADED = true; LIVE = {}; return LIVE; });
  }

  var CSS = [
    '#menu{display:none!important}',
    '.pb-cart-word,.pb-cart-sep{display:none!important}',
    '#cart,a.pb-pill.primary[href="/cart"]{display:inline-flex!important;align-items:center;gap:7px}',
    '#cart{border:1.5px solid #141210;border-radius:100px;padding:8px 13px;color:#141210;text-decoration:none;line-height:1;font-weight:800;font-size:12.5px}',
    '#cart b{color:#FF4B18;font-size:12.5px;line-height:1}',
    '@media(max-width:980px){#cart{display:inline-flex!important}nav .nav-r{gap:7px}}',
    'a.pb-pill.primary[href="/cart"] .pb-cartcount{margin-left:0}',
    '.pb-fab{position:fixed;right:16px;bottom:18px;z-index:9999;display:none;align-items:center;gap:9px;background:#141210;color:#fff;border-radius:100px;padding:13px 19px;text-decoration:none;font-family:inherit;font-weight:800;font-size:14px;line-height:1;box-shadow:0 10px 28px rgba(20,18,16,.32)}',
    '.pb-fab b{background:#FF4B18;color:#fff;border-radius:99px;min-width:21px;height:21px;display:inline-flex;align-items:center;justify-content:center;font-size:12px;padding:0 6px}',
    '.pb-fab.on{display:inline-flex}',
    '@media(min-width:981px){.pb-fab{display:none!important}}',
    '.pb-left{display:inline-flex;align-items:center;gap:5px;margin:6px 0 0;font-family:inherit;font-size:10.5px;font-weight:800;letter-spacing:.04em;text-transform:uppercase;color:#B4361F;background:rgba(255,75,24,.10);border:1px solid rgba(255,75,24,.30);border-radius:100px;padding:4px 9px;line-height:1}',
    '.pb-left--low{color:#8E2513;background:rgba(255,75,24,.18);border-color:rgba(255,75,24,.5)}',
    '.pb-ph-left{position:absolute;top:10px;left:10px;z-index:3;margin:0}',
    '.pb-soldout-hidden{display:none!important}',
    '.pbc-view.join,.pbc-view.join:link,.pbc-view.join:visited,.pbc-view.join:hover{color:#ffffff!important}',
    '.pbc-lock a,.pbc-lock b,.meal .add[href*="membership"]{color:#ffffff!important}',
    '.meal .chip.pb-macro-grid,.pbc-card .chip.pb-macro-grid,.pbc-card .pbc-macros.pb-macro-grid,.pb-uc .chip.pb-macro-grid{top:auto!important;bottom:10px;left:10px;right:10px;width:auto!important;max-width:none!important;display:grid!important;grid-template-columns:repeat(2,minmax(0,1fr));gap:1px;background:rgba(11,11,10,.82)!important;backdrop-filter:blur(7px);-webkit-backdrop-filter:blur(7px);border:1px solid rgba(255,255,255,.18);border-radius:10px!important;padding:1px!important;white-space:normal!important;overflow:visible!important}',
    '.pb-macro-item{display:flex;flex-direction:column;align-items:center;justify-content:center;min-height:42px;padding:5px 7px;text-align:center;background:rgba(255,255,255,.07)}',
    '.pb-macro-item:nth-child(1){border-radius:8px 0 0 0}.pb-macro-item:nth-child(2){border-radius:0 8px 0 0}.pb-macro-item:nth-last-child(1):nth-child(odd){grid-column:1/-1;border-radius:0 0 8px 8px}',
    '.pb-macro-value{font-size:11px;font-weight:900;line-height:1.05;color:#fff}.pb-macro-label{margin-top:3px;font-size:8px;font-weight:700;line-height:1;text-transform:uppercase;letter-spacing:.08em;color:rgba(255,255,255,.76)}',
    '.pb-pack-note{display:block;margin:3px 0 7px;font-size:10px;font-weight:800;letter-spacing:.08em;text-transform:uppercase;color:#747470}',
    '.pb-no-member-price .mem,.pb-no-member-price [class*="member-price"],.pb-no-member-price [class*="memberPrice"]{display:none!important}',
    '.pb-no-member-price .reg{display:inline!important;text-decoration:none!important;color:inherit!important}',
    '.pb-size-picker{display:grid;gap:5px;margin:10px 0 8px}.pb-size-picker label{font-size:10px;font-weight:800;letter-spacing:.08em;text-transform:uppercase;color:#747470}.pb-size-picker select{width:100%;min-height:42px;padding:8px 11px;border:1.5px solid #141210;border-radius:8px;background:#fff;color:#141210;font:700 13px inherit}',
    '.pb-member-join{display:inline-flex!important;align-items:center;justify-content:center;text-decoration:none!important}',
    /* member price hero, regular struck through beside it */
    '#car1.memon .pblock{flex-direction:row;align-items:baseline;gap:7px;flex-wrap:wrap}',
    '#car1.memon .pblock .mem{order:1;font-family:var(--disp);font-weight:900;font-size:16px;color:var(--teal)}',
    '#car1.memon .pblock .reg{order:2;display:inline!important;font-family:var(--mono);font-size:11px;font-weight:600;color:var(--gray);text-decoration:line-through}',
    '#quickPlans:not(.regular-mode) .regular-current{display:inline!important;font-size:17px;color:var(--gray);text-decoration:line-through!important}',
    '#quickPlans:not(.regular-mode) .regular-current:after{display:none!important}',
    '#quickPlans:not(.regular-mode) .member-current{font-size:34px;color:var(--ink);text-decoration:none!important}',
    '#quickPlans:not(.regular-mode) .member-current:after{display:none!important}',
    '#quickPlans:not(.regular-mode) .pricepair{flex-direction:row-reverse;justify-content:flex-end}',
    /* quadrant alignment */
    '.pbhero.quick .quickplans{grid-template-columns:2fr 1fr!important;align-items:stretch!important}',
    '.pbhero.quick .qplan-combined,.pbhero.quick .qplan-membership{height:100%;display:flex;flex-direction:column}',
    '.pbhero.quick .qplan-combined .qpc-cols{flex:1;align-items:stretch}',
    '.pbhero.quick .qpc-col{min-height:0!important;justify-content:flex-start}',
    '.pbhero.quick .qplan-membership{min-height:0!important;padding:18px 20px}',
    '@media(max-width:900px){.pbhero.quick .quickplans{grid-template-columns:1fr!important}.pbhero.quick .qplan-combined{grid-column:span 1}}',
    /* hero seals */
    '.pb-seals{display:flex;gap:8px;flex-wrap:wrap;justify-content:center;margin:18px auto 0}',
    '.pb-seals span{display:inline-flex;align-items:center;gap:6px;font-family:var(--mono),monospace;font-size:10px;font-weight:600;letter-spacing:.1em;text-transform:uppercase;color:#0B0B0A;background:#fff;border:1.5px solid #0B6B3A;border-radius:100px;padding:7px 13px;line-height:1}',
    '.pb-seals span:before{content:"";width:7px;height:7px;border-radius:50%;background:#0B6B3A;flex:0 0 auto}',
    '@media(max-width:520px){.pb-seals span{font-size:9px;padding:6px 10px;letter-spacing:.06em}}',
    /* ---- product page ---- */
    'body.pb-pdp .quantity-selector,body.pb-pdp quantity-selector-component,',
    'body.pb-pdp .product-form__quantity,body.pb-pdp .product-form-buttons__quantity{display:none!important}',
    '.pb-pdp-lock{position:absolute;inset:0;z-index:5;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:9px;text-align:center;padding:20px;background:rgba(11,11,10,.42);border-radius:inherit}',
    '.pb-pdp-lock b{font-family:inherit;font-weight:900;font-size:17px;color:#fff;letter-spacing:-.01em}',
    '.pb-pdp-lock a{background:#0B6B3A;color:#fff!important;border-radius:100px;padding:11px 20px;font-weight:800;font-size:13px;text-decoration:none}',
    '.pb-blurred img,.pb-blurred video{filter:blur(16px) brightness(.86) saturate(1.05);transform:scale(1.06)}',
    '.pb-blurred{position:relative;overflow:hidden}',
    '.pb-memprice{display:flex;align-items:baseline;gap:10px;flex-wrap:wrap;margin:2px 0 6px}',
    '.pb-memprice .now{font-family:inherit;font-weight:900;font-size:30px;line-height:1;color:#0B6B3A}',
    '.pb-memprice .was{font-size:16px;color:#747470;text-decoration:line-through;font-weight:600}',
    '.pb-memprice .tag{font-size:10px;font-weight:800;letter-spacing:.08em;text-transform:uppercase;color:#0B6B3A;background:rgba(11,107,58,.1);border-radius:100px;padding:4px 9px}',
    '.pb-memnote{font-size:12px;color:#747470;margin:0 0 10px}',
    '.pb-memnote a{color:#FF4B18;font-weight:800}'
  ].join('\n');

  function injectCss() {
    if (document.getElementById('pb-global-css')) return;
    var s = document.createElement('style');
    s.id = 'pb-global-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  /* ---------- product page ---------- */
  function productPage() {
    var P = window.PB_PRODUCT;
    if (!P) return;
    document.body.classList.add('pb-pdp');

    /* member gating: blur the real photo, never a flat colour block */
    if (P.memberOnly && !window.PB_MEMBER) {
      var media = document.querySelector('.product-media-container, .product-media, .media-gallery, [class*="product-media"]');
      if (media && !media.querySelector('.pb-pdp-lock')) {
        media.classList.add('pb-blurred');
        if (window.getComputedStyle(media).position === 'static') media.style.position = 'relative';
        if (!media.querySelector('img') && P.image) {
          var img = document.createElement('img');
          img.src = P.image;
          img.alt = P.title;
          img.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;border-radius:inherit';
          media.appendChild(img);
        }
        var lock = document.createElement('div');
        lock.className = 'pb-pdp-lock';
        lock.innerHTML = '<span style="font-size:26px">&#128274;</span>' +
          '<b>Members Only</b>' +
          '<a href="/products/protein-bodega-membership">Join to unlock</a>';
        media.appendChild(lock);
      }
      document.querySelectorAll('.product-form__buttons, .product-form-buttons, [class*="buy-buttons"]').forEach(function (b) {
        b.style.display = 'none';
      });
    }

    var productText = [P.title, P.handle, P.productType].join(' ').toLowerCase();
    var planProduct = /meal.?plan|5.?meal|10.?meal/.test(productText);
    if (!planProduct) {
      document.querySelectorAll('.pb-memprice,.pb-memnote').forEach(function (el) { el.remove(); });
      document.querySelectorAll('.product-price,.price,[class*="product-info"] [class*="price"]').forEach(function (el) { el.style.display = ''; });
    }
    if (P.discountable && planProduct && !document.querySelector('.pb-memprice')) {
      var priceEl = document.querySelector('.product-price, .price, [class*="product-info"] [class*="price"]');
      if (priceEl) {
        var box = document.createElement('div');
        box.className = 'pb-memprice';
        box.innerHTML = '<span class="now">' + money(P.memberPrice) + '</span>' +
          '<span class="was">' + money(P.price) + '</span>' +
          '<span class="tag">Member price</span>';
        var note = document.createElement('p');
        note.className = 'pb-memnote';
        note.innerHTML = window.PB_MEMBER
          ? 'Member pricing applied at checkout.'
          : 'Member price shown. <a href="/products/protein-bodega-membership">Become a member</a> to unlock it.';
        priceEl.parentNode.insertBefore(box, priceEl.nextSibling);
        box.parentNode.insertBefore(note, box.nextSibling);
        priceEl.style.display = 'none';
      }
    }
  }

  function trimNav() {
    var drop = document.querySelector('.nav-links .drop');
    if (drop) {
      Array.prototype.slice.call(drop.querySelectorAll('a')).forEach(function (a) {
        var label = (a.textContent || '').trim().toLowerCase();
        var href = (a.getAttribute('href') || '').toLowerCase();
        if (DROP_NAV.indexOf(label) !== -1 || href.indexOf('lean-high-protein') !== -1) a.remove();
      });
      if (!drop.querySelector('a[href*="/collections/merch"]')) {
        var m = document.createElement('a');
        m.href = '/collections/merch';
        m.setAttribute('data-en', 'Merch');
        m.setAttribute('data-es', 'Merch');
        m.textContent = 'Merch';
        drop.appendChild(m);
      }
    }
    document.querySelectorAll('footer .fcol a[href*="lean-high-protein"]').forEach(function (a) { a.remove(); });
    document.querySelectorAll('footer .fcol').forEach(function (col) {
      var h = col.querySelector('h5');
      if (!h) return;
      if ((h.getAttribute('data-en') || h.textContent || '').trim().toLowerCase() !== 'shop') return;
      if (col.querySelector('a[href*="/collections/merch"]')) return;
      var a = document.createElement('a');
      a.href = '/collections/merch';
      a.setAttribute('data-en', 'Merch');
      a.setAttribute('data-es', 'Merch');
      a.textContent = 'Merch';
      col.appendChild(a);
    });
  }

  function homepageTidy() {
    var af = document.getElementById('afilter');
    if (af) af.remove();
    var addons = document.getElementById('addons');
    if (addons) addons.querySelectorAll('.section-link').forEach(function (a) { a.remove(); });
    document.querySelectorAll('#addoncar .meal .badge').forEach(function (b) {
      var t = (b.getAttribute('data-en') || b.textContent || '').trim().toLowerCase();
      if (t === 'signature') b.remove();
    });
  }

  function cleanProductName(text) {
    return String(text || '')
      .replace(/^\s*5\s*oz\s*/i, '')
      .replace(/cr[eè]me\s+br[uû]l[eé]e/ig, 'Crème Caramel')
      .replace(/\s*[—–-]\s*members?\s+only/ig, ' Members Only')
      .trim();
  }

  function metricParts(text) {
    var source = String(text || '').replace(/\s+/g, ' ').trim();
    var patterns = [
      { re: /(\d+(?:\.\d+)?)\s*(?:calories|cal|kcal)\b/i, label: 'Calories', suffix: '' },
      { re: /(\d+(?:\.\d+)?)\s*g(?:rams?)?\s*(?:of\s*)?protein\b/i, label: 'Protein', suffix: 'g' },
      { re: /(\d+(?:\.\d+)?)\s*g(?:rams?)?\s*(?:of\s*)?(?:carbs?|carbohydrates?)\b/i, label: 'Carbs', suffix: 'g' },
      { re: /(\d+(?:\.\d+)?)\s*g(?:rams?)?\s*(?:of\s*)?fat\b/i, label: 'Fat', suffix: 'g' }
    ];
    var parts = [];
    patterns.forEach(function (pattern) {
      var match = source.match(pattern.re);
      if (match) parts.push({ value: match[1] + pattern.suffix, label: pattern.label });
    });
    return parts;
  }

  function addOnSalesCopy(text) {
    var source = String(text || '').toLowerCase();
    if (source.indexOf('lean green') > -1) return 'A crisp blend of greens, fruit and citrus that makes adding more produce to your day refreshingly easy.';
    if (source.indexOf('golden fire') > -1) return 'A bright, spicy kick of ginger, turmeric, cayenne and citrus for mornings or whenever your taste buds need a wake-up call.';
    if (source.indexOf('burrito') > -1) return 'A satisfying 42g protein breakfast you can grab and go. Eggs, egg whites, bacon and mozzarella keep busy mornings simple.';
    if (source.indexOf('banana bread') > -1) return 'Six soft, protein packed bites for breakfast, coffee breaks or an easy post-workout snack.';
    if (source.indexOf('choco date') > -1) return 'Rich, chewy chocolate and naturally sweet dates in an easy pack of five for the afternoon craving that refuses to leave.';
    if (/cr[eè]me\s+(br[uû]l[eé]e|caramel)/i.test(source)) return 'Your macros behaved all week. Let dessert have a turn. Silky custard with caramel crunch served on the side.';
    return '';
  }

  function scrubBurritoMemberClaim() {
    if (!/burrito/i.test(document.body.textContent || '')) return;
    document.querySelectorAll('main p,main small,main li,main div').forEach(function (el) {
      if (el.children.length) return;
      var text = (el.textContent || '').trim();
      if (!/become a member\s*(and|&)\s*pay\s*\$?9|members?\s+pay\s*\$?9/i.test(text)) return;
      var cleaned = text
        .replace(/become a member\s*(and|&)\s*pay\s*\$?9\.?/ig, '')
        .replace(/members?\s+pay\s*\$?9\.?/ig, '')
        .trim();
      if (cleaned) el.textContent = cleaned;
      else el.remove();
    });
  }

  function formatMacros() {
    document.querySelectorAll('#addoncar .chip,#treatcar .chip,#pb-upsell-all .chip,.pbc-card .chip,.pbc-card .pbc-macros,.pb-uc .chip').forEach(function (chip) {
      if (chip.classList.contains('pb-macro-grid')) return;
      var parts = metricParts(chip.textContent);
      if (!parts.length) return;
      chip.classList.add('pb-macro-grid');
      chip.textContent = '';
      parts.forEach(function (part) {
        var item = document.createElement('span');
        item.className = 'pb-macro-item';
        item.innerHTML = '<span class="pb-macro-value">' + part.value + '</span><span class="pb-macro-label">' + part.label + '</span>';
        chip.appendChild(item);
      });
    });
  }

  function cleanCards() {
    document.querySelectorAll('#addoncar .meal,#treatcar .meal,#pb-upsell-all .meal,.pbc-card,.pb-uc').forEach(function (card) {
      var full = (card.textContent || '').toLowerCase();
      var salesCopy = addOnSalesCopy(full);
      var isPlan = /\b(5|10)\s*meal\s*plan\b|meal\s*plan/.test(full);
      if (!isPlan) {
        card.classList.add('pb-no-member-price');
        card.querySelectorAll('.mem,[class*="member-price"],[class*="memberPrice"]').forEach(function (el) { el.remove(); });
        card.querySelectorAll('p,small,span,div').forEach(function (el) {
          if (el.children.length) return;
          var text = (el.textContent || '').trim();
          if (/become a member\s*(and|&)\s*pay|members?\s+pay|member price/i.test(text)) el.remove();
        });
      }
      card.querySelectorAll('h1,h2,h3,h4,.title,.pbc-title,.pb-uc__title').forEach(function (el) {
        var next = cleanProductName(el.textContent);
        if (next && next !== el.textContent.trim()) el.textContent = next;
      });
      if (salesCopy) {
        var description = card.querySelector('.treat-detail,.pbc-body > p,.bd > p,.pb-uc__body > p');
        if (description) description.textContent = salesCopy;
      }
      if (/banana bread bites/.test(full)) {
        var title = card.querySelector('h1,h2,h3,h4,.title,.pbc-title,.pb-uc__title');
        if (title) {
          title.textContent = 'Banana Bread Bites';
          if (!card.querySelector('.pb-pack-note')) {
            var pack = document.createElement('span');
            pack.className = 'pb-pack-note';
            pack.textContent = 'Pack of 6';
            title.insertAdjacentElement('afterend', pack);
          }
        }
        card.querySelectorAll('.chip').forEach(function (chip) {
          if (/260/.test(chip.textContent) && !/per pack/i.test(chip.textContent)) chip.setAttribute('aria-label', '260 calories per pack of 6');
        });
      }
      if (/cr[eè]me\s+(br[uû]l[eé]e|caramel)/i.test(full)) {
        card.style.display = '';
        card.classList.remove('locked', 'faded', 'blurred', 'pb-blurred');
        card.querySelectorAll('.pbc-lock,[class*="unlock-overlay"]').forEach(function (overlay) { overlay.remove(); });
        card.querySelectorAll('img').forEach(function (img) {
          img.style.setProperty('filter', 'none', 'important');
          img.style.removeProperty('transform');
          img.classList.remove('blurred', 'pb-blurred');
        });
        var button = card.querySelector('.add,.pbc-view,.pb-uc__button,button[type="submit"]');
        var href = button && button.getAttribute ? (button.getAttribute('href') || '') : '';
        if (button && !window.PB_MEMBER) {
          if (button.tagName === 'A') {
            button.href = '/products/protein-bodega-membership';
            button.classList.add('join', 'pb-member-join');
            button.textContent = 'Join';
          } else {
            var join = document.createElement('a');
            join.href = '/products/protein-bodega-membership';
            join.className = (button.className || '') + ' join pb-member-join';
            join.textContent = 'Join';
            button.replaceWith(join);
          }
        } else if (button && /membership/.test(href)) {
          button.textContent = 'Join';
        }
      }
    });
  }

  function merchSizes() {
    if (!/\/collections\/merch/.test(window.location.pathname)) return;
    document.querySelectorAll('.pbc-card,.meal,.pb-uc').forEach(function (card) {
      if (card.querySelector('.pb-size-picker')) return;
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      var handleMatch = (link.getAttribute('href') || '').match(/\/products\/([^?#/]+)/);
      if (!handleMatch) return;
      fetch('/products/' + handleMatch[1] + '.js').then(function (r) { return r.json(); }).then(function (product) {
        if (!product.variants || product.variants.length < 2 || card.querySelector('.pb-size-picker')) return;
        var optionNames = (product.options || []).map(function (option) {
          return String(option && option.name ? option.name : option);
        }).filter(function (name) { return name && name.toLowerCase() !== 'title'; });
        var label = 'Select option';
        if (/distressed-dad-hat/.test(handleMatch[1]) || optionNames.join(' ').toLowerCase().indexOf('color') !== -1) label = 'Select color';
        else if (optionNames.length === 1 && optionNames[0].toLowerCase().indexOf('size') !== -1) label = 'Select size';
        else if (optionNames.length > 1) label = 'Select ' + optionNames.join(' & ').toLowerCase();
        var options = product.variants.filter(function (variant) { return variant.available; }).map(function (variant) {
          return '<option value="' + variant.id + '">' + variant.title + '</option>';
        }).join('');
        if (!options) return;
        var picker = document.createElement('div');
        picker.className = 'pb-size-picker';
        picker.innerHTML = '<label>' + label + '</label><select aria-label="' + label + '">' + options + '</select>';
        var host = card.querySelector('.pbc-body,.bd,.pb-uc__body') || card;
        var action = host.querySelector('.pbc-view,.add,.pb-uc__button,button[type="submit"]');
        if (action) action.insertAdjacentElement('beforebegin', picker); else host.appendChild(picker);
        var select = picker.querySelector('select');
        function selectVariant() {
          card.querySelectorAll('[data-variant-id]').forEach(function (el) { el.setAttribute('data-variant-id', select.value); });
          card.querySelectorAll('input[name="id"]').forEach(function (input) { input.value = select.value; });
        }
        select.addEventListener('change', selectVariant);
        selectVariant();
      }).catch(function () {});
    });
  }

  function memberFirst() {
    var qp = document.getElementById('quickPlans');
    if (qp && !qp.getAttribute('data-pb-member')) {
      qp.setAttribute('data-pb-member', '1');
      qp.classList.remove('regular-mode');
      var ps = document.getElementById('priceSwitch');
      if (ps) ps.querySelectorAll('button').forEach(function (b) {
        b.classList.toggle('on', b.getAttribute('data-mode') === 'member');
      });
      var ctx = document.getElementById('priceContext');
      if (ctx) ctx.textContent = 'Member prices shown';
    }
    var car = document.getElementById('car1');
    if (car && !car.getAttribute('data-pb-member')) {
      car.setAttribute('data-pb-member', '1');
      car.classList.add('memon');
      var mt = document.getElementById('memtoggle');
      if (mt) mt.classList.add('on');
    }
  }

  function heroSeals() {
    var sub = document.querySelector('.pbhero.quick .pbhero-sub');
    if (!sub || document.querySelector('.pb-seals')) return;
    var wrap = document.createElement('div');
    wrap.className = 'pb-seals';
    SEALS.forEach(function (s) {
      var el = document.createElement('span');
      el.setAttribute('data-en', s.en);
      el.setAttribute('data-es', s.es);
      el.textContent = s.en;
      wrap.appendChild(el);
    });
    sub.parentNode.insertBefore(wrap, sub.nextSibling);
  }

  function hideSoldOut() {
    if (!/\/collections\/merch/.test(window.location.pathname)) return;
    document.querySelectorAll('.pbc-card').forEach(function (card) {
      var btn = card.querySelector('.pbc-view');
      var txt = btn ? (btn.textContent || '').trim().toLowerCase() : '';
      var out = (btn && btn.hasAttribute('disabled')) || txt === 'sold out' || txt === 'agotado';
      card.classList.toggle('pb-soldout-hidden', !!out);
    });
  }

  function iconifyCart() {
    var home = document.getElementById('cart');
    if (home && !home.getAttribute('data-pb-icon')) {
      home.setAttribute('data-pb-icon', '1');
      home.setAttribute('aria-label', 'Cart');
      home.setAttribute('title', 'Cart');
      var word = home.querySelector('span');
      if (word) word.classList.add('pb-cart-word');
      Array.prototype.slice.call(home.childNodes).forEach(function (n) {
        if (n.nodeType === 3 && n.nodeValue.replace(/\s/g, '') !== '') {
          var s = document.createElement('span');
          s.className = 'pb-cart-sep';
          s.textContent = n.nodeValue;
          n.parentNode.replaceChild(s, n);
        }
      });
      home.insertAdjacentHTML('afterbegin', BAG_SVG);
    }
    document.querySelectorAll('a.pb-pill.primary[href="/cart"]').forEach(function (pill) {
      if (pill.getAttribute('data-pb-icon')) return;
      pill.setAttribute('data-pb-icon', '1');
      pill.setAttribute('aria-label', 'Cart');
      pill.setAttribute('title', 'Cart');
      Array.prototype.slice.call(pill.childNodes).forEach(function (n) {
        if (n.nodeType === 3) n.parentNode.removeChild(n);
      });
      pill.insertAdjacentHTML('afterbegin', BAG_SVG);
    });
  }

  function variantIdOf(card) {
    var el = card.querySelector('[data-variant-id]');
    if (el) return String(el.getAttribute('data-variant-id') || '').trim();
    var input = card.querySelector('input[name="id"]');
    if (input) return String(input.value || '').trim();
    if (card.hasAttribute('data-variant')) return String(card.getAttribute('data-variant')).trim();
    return '';
  }

  function stockBadges() {
    var STOCK = window.PB_STOCK;
    if (!STOCK) return;
    document.querySelectorAll('.meal, .pb-uc, .pbc-card').forEach(function (card) {
      var vid = variantIdOf(card);
      var left = vid ? STOCK[vid] : null;
      var existing = card.querySelector('.pb-left');
      if (!left) { if (existing) existing.remove(); return; }
      if (existing) {
        if (existing.getAttribute('data-n') === String(left)) return;
        existing.remove();
      }
      var tag = document.createElement('span');
      tag.className = 'pb-left' + (left <= 10 ? ' pb-left--low' : '');
      tag.setAttribute('data-n', String(left));
      tag.textContent = 'Only ' + left + ' left';
      var body = card.querySelector('.bd, .pbc-body, .pb-uc__body');
      if (body) {
        var anchor = body.querySelector('.row, .pbc-row, .treat-row');
        if (anchor) body.insertBefore(tag, anchor); else body.appendChild(tag);
        return;
      }
      var ph = card.querySelector('.ph, .pbc-ph, .pb-uc__img');
      if (!ph) return;
      if (window.getComputedStyle(ph).position === 'static') ph.style.position = 'relative';
      tag.className += ' pb-ph-left';
      ph.appendChild(tag);
    });
  }

  function remapVariants() {
    Object.keys(REMAP).forEach(function (oldId) {
      document.querySelectorAll('[data-variant-id="' + oldId + '"]').forEach(function (btn) {
        btn.setAttribute('data-variant-id', REMAP[oldId]);
        if (btn.dataset) btn.dataset.variantId = REMAP[oldId];
      });
    });
  }

  function repairCards() {
    if (!LIVE) return;
    SCOPES.forEach(function (scopeSel) {
      var scope = document.querySelector(scopeSel);
      if (!scope) return;
      scope.querySelectorAll(CARD_SEL).forEach(function (card) {
        if (card.closest('.qplan, .qpc-col, .quickplans')) return;
        var btn = card.querySelector('[data-variant-id]');
        if (!btn) return;
        var vid = String(btn.getAttribute('data-variant-id') || '').trim();
        if (!vid || card.getAttribute('data-pb-fixed') === vid) return;
        var p = LIVE[vid];
        if (!p) {
          if (scopeSel === '#pb-upsell-all') card.remove();
          else card.style.display = 'none';
          return;
        }
        card.setAttribute('data-pb-fixed', vid);
        card.style.display = '';
        var img = card.querySelector('img');
        if (img && p.img) {
          var base = p.img.split('?')[0];
          if ((img.getAttribute('src') || '').indexOf(base) === -1) {
            img.setAttribute('src', base + '?width=720');
            img.removeAttribute('srcset');
            if (!img.alt) img.alt = p.title;
          }
        }
        var reg = card.querySelector('.reg, .pb-uc__price');
        if (reg && p.price && !reg.querySelector('*')) reg.textContent = p.price;
        card.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
          a.setAttribute('href', '/products/' + p.handle);
        });
      });
    });
  }

  function ensureFab() {
    var fab = document.getElementById('pb-fab');
    if (fab) return fab;
    fab = document.createElement('a');
    fab.id = 'pb-fab';
    fab.className = 'pb-fab';
    fab.href = '/cart';
    fab.setAttribute('aria-label', 'View cart');
    fab.innerHTML = '<span>View cart</span><b>0</b>';
    document.body.appendChild(fab);
    return fab;
  }

  function paintCount(count) {
    var own = document.getElementById('cartn');
    if (own) own.textContent = count;
    document.querySelectorAll('[data-cart-count], .cart-count, .cart-icon__count').forEach(function (el) {
      el.textContent = count;
    });
    var fab = ensureFab();
    fab.querySelector('b').textContent = count;
    fab.classList.toggle('on', count > 0);
  }

  function refreshCount() {
    return fetch('/cart.js').then(function (r) { return r.json(); })
      .then(function (c) { paintCount(c.item_count || 0); }).catch(function () {});
  }

  function run() {
    injectCss();
    iconifyCart();
    trimNav();
    homepageTidy();
    cleanCards();
    scrubBurritoMemberClaim();
    formatMacros();
    merchSizes();
    memberFirst();
    heroSeals();
    productPage();
    remapVariants();
    repairCards();
    stockBadges();
    hideSoldOut();
  }

  function boot() {
    run();
    loadLive().then(function () { run(); refreshCount(); });
    setTimeout(run, 400);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  ['cart:updated', 'cart:refresh', 'shopify:section:load'].forEach(function (evt) {
    document.addEventListener(evt, function () { run(); refreshCount(); });
  });

  var obs = new MutationObserver(function () {
    clearTimeout(window.__pbGT);
    window.__pbGT = setTimeout(run, 250);
  });
  if (document.body) obs.observe(document.body, { childList: true, subtree: true });

  var _fetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    var out = _fetch.apply(this, arguments);
    if (typeof url === 'string' && url.indexOf('/cart/') !== -1) {
      out.then(function () { setTimeout(refreshCount, 250); }).catch(function () {});
    }
    return out;
  };

  window.pbRefreshCartCountGlobal = refreshCount;
})();
